import { render, staticRenderFns } from "./SerieTreatment.vue?vue&type=template&id=1f26c42f"
import script from "./SerieTreatment.vue?vue&type=script&lang=js"
export * from "./SerieTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports